export default function stripHTMLStringFormatter(text) {
  if (typeof text !== 'string' || !text) {
    return
  }
  return text.replace(/<(?:.|\n)*?>/gm, '')
}
